import gql from 'graphql-tag';

export default gql`
	query searchdatenow {
		dateNow {
			now
		}
	}
`;
